var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeoLocation = function SvgGeoLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "M11 2.06a8.54 8.54 0 0 0-5.37 14.18L10 21.09a2.7 2.7 0 0 0 4 0l4.35-4.85A8.55 8.55 0 0 0 11 2.06m1 11.69a3.21 3.21 0 1 1-.02-6.42 3.21 3.21 0 0 1 .02 6.42",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "M12 13.84a3.38 3.38 0 1 0 0-6.76 3.38 3.38 0 0 0 0 6.76"
  })));
};
export default SvgGeoLocation;